module.exports = __webpack_public_path__ + "img/bttn_gift_incomplete.611dcf19.png";